import { render, staticRenderFns } from "./Order-create-modal.vue?vue&type=template&id=ed04c9bc&scoped=true&"
import script from "./Order-create-modal.vue?vue&type=script&lang=js&"
export * from "./Order-create-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed04c9bc",
  null
  
)

export default component.exports